module.exports = __webpack_public_path__ + "static/media/setaVerde.ab1b0758.svg";